import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-6xl font-bold text-muted-foreground">404</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-muted-foreground">
            <p className="text-lg">Page not found</p>
            <p className="text-sm mt-2">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="flex gap-2 justify-center">
            <Button asChild variant="outline">
              <Link to="/" onClick={() => window.history.back()}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back
              </Link>
            </Button>
            <Button asChild>
              <Link to="/lobby">
                <Home className="h-4 w-4 mr-2" />
                Go to Lobby
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
